var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{staticClass:"font-weight-bold",attrs:{"color":_vm.boolean ? 'success' : 'error',"text-color":"white","small":""}},[_vm._v(" "+_vm._s(_vm.$t(`miscellaneous.${_vm.boolean ? 'yes' : 'no'}`))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }